
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { ThankYouPopupComponent } from '../thank-you-popup/thank-you-popup.component';
import { MiteventsService } from '../../mitevents.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Constants } from '../constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit{
  isInternshipRoute: boolean = false;
  constructor(private router: Router,private fb: FormBuilder, private http: HttpClient, private eventService: MiteventsService, private dialog: MatDialog) {}
  subscribeForm !: FormGroup ;
  currentYear!: number;
  message: string = '';
  loading = false;
  showThankYouPopUp: boolean = false;
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
webUrl=Constants.webURL;
  ngOnInit(): void {
    this.router.events.subscribe(event => {
        this.isInternshipRoute = this.router.url === '/internship';
    });
    this.subscribeForm = this.fb.group({
      subscribeEmail: ['', [Validators.required, Validators.email]]
    });

    this.currentYear = new Date().getFullYear(); // Get the current year
 
  }

  onSubmit(): void {
    if (this.subscribeForm.valid) {
      this.loading = true;
      this.message = '';
      this.showThankYouPopUp = true;
  
      const formData = new FormData();
      formData.append('Email', this.subscribeForm.value.subscribeEmail);
      formData.append('Type', 'subscribe_Form');
      
      this.eventService.SendSubscriberDetails(formData).subscribe(
        (res: any) => {
          // console.log('Success:', res);
          this.subscribeForm.reset();
          this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
            data: {
              title: 'Thanks For Subscribing',
              message: 'You can get the latest updates'
            }
          });
          
          // Automatically close the dialog after 5 seconds (5000 ms)
          setTimeout(() => {
            if (this.dialogRef) {
              this.dialogRef.close();
            }
            this.loading = false; // Ensure loading is stopped
          }, 5000);
        },
        (err: HttpErrorResponse) => {
          this.loading = false;
          this.message = this.handleError(err);
          this.showThankYouPopUp = false;
        }
      );
    } else {
      this.message = 'Please enter a valid email';
      this.subscribeForm.reset();
    }
  }
  

  handleError(err: HttpErrorResponse): string {
    // if (err.status === 409) {
    //   return 'This email is already subscribed.';
    // }
    return 'An unexpected error occurred. Please try again later.';
  }

  onEmailChange(): void {
    const emailControl = this.subscribeForm.get('subscribeEmail');
    const regexp = /^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/;
    const email = emailControl?.value;

    if (!email) {
      this.message = 'Email is required.';
      emailControl?.setErrors({ required: true });
    } else if (!regexp.test(email)) {
      this.message = 'Enter a valid business email.';
      emailControl?.setErrors({ pattern: true });
    } else {
      this.message = '';
      emailControl?.setErrors(null);
    }
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
